<template>
    <div class="head" v-loading="loading">
        <div class="m-login-header">
            <div class="m-header-content g-wrapper" style="padding-left: 200px;">
                <a href="/" class="header-item">
                    <img src="../assets/picture/logo-xs-kpr.jpg" style="width: 300px; height: 50px;" />
                </a>
                <div class="header-item theme">欢迎登录</div>
                <!-- <div class="login-header-right">
          <a href="javascript:void 0;" class="zhiCustomBtn">点击QQ咨询</a>
          <img src="../assets/picture/head_number@2x.png">
        </div>-->
            </div>
        </div>

        <div class="m-login-contain">
            <div class="g-wrapper g-clearfix">
                <div class="m-login-panel">
                    <div class="header">用户登录</div>
                    <div class="error-message hide" id="showError"></div>
                    <div class="m-login-form" id="loginForm">
                        <div class="form-line">
                            <div class="content">
                                <input type="text" v-model="username" placeholder="用户名" class="short" name="username" />
                                <i class="ico ico-account"></i>
                            </div>
                        </div>
                        <div class="form-line">
                            <div class="content">
                                <input
                                    type="password"
                                    v-model="password"
                                    placeholder="登录密码"
                                    class="short"
                                    name="password"
                                    @keypress="enterLogin($event)"
                                />
                                <i class="ico ico-password"></i>
                            </div>
                        </div>
                        <div class="form-line hide" id="captchaWrap">
                            <div class="item-cont">
                                <div class="captcha" id="captcha"></div>
                            </div>
                        </div>
                        <button class="form-btn" id="submitBtn" @click="login">登录</button>
                        <!-- <div class="form-line">
              <a href="/repassword" class="bottom-a">忘记密码</a>
              <a href="/register" class="reg-btn bottom-a">免费注册</a>
            </div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GlobalFun } from '@/common/utils';
import { LoginValidateForPortal } from '../common/api';
export default {
    name: 'login',
    data() {
        return {
            username: '',
            password: '',
            loading: false,
            bootPath: 'http://mallmgr.cesseon.com/api/', //SeekerBase/LoginValidateForPortal
            //http://mallmgr.cesseon.com/api/Dic/GetProductSKUListInPortal?sku=1267425
            url: ''
        };
    },
    methods: {
        enterLogin(e) {
            if (e.keyCode == 13) {
                this.login();
            }
        },
        async login() {
            if (!this.username) {
                this.$message({
                    message: '用户名不能为空！',
                    type: 'warning'
                });
                return;
            }
            if (!this.password) {
                this.$message({
                    message: '密码不能为空！',
                    type: 'warning'
                });
                return;
            }
            this.loading = true;
            LoginValidateForPortal({
                username: this.username,
                pwd: this.password
            })
                .then(res => {
                    GlobalFun.setCookie('UserInfo', res);
                    if (this.url) {
                        this.$router.push(this.url);
                    } else {
                        this.$router.push('/');
                    }
                })
                .catch(err => {})
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    async mounted() {
        this.url = this.$route.query.url;
    }
};
</script>

<style>
@import url('../assets/css/login.css');
</style>
